import { render, staticRenderFns } from "./safesWithdrawals.vue?vue&type=template&id=4e5cc078&"
import script from "./safesWithdrawals.vue?vue&type=script&lang=js&"
export * from "./safesWithdrawals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports